import angular from "angular"
import { $uniUP } from "../.."
import { IUniConfig } from "../../../uni-base/uni-base-module"
import { SidebarManagerController } from "./sidebar-manager"

export type ISidebar = {
    visible: boolean
    open: () => void
    close: () => void
    toggle: () => void
}

interface ISidebarScope extends ng.IScope {
    visible: boolean
    visibleInternal: boolean
    key: string
    idpanel: string
    onClose: () => void
}

class SidebarController implements ISidebar {
    constructor(private sidebarScope: ISidebarScope) { }

    get visible() {
        return this.sidebarScope.visible
    }

    open() {
        this.sidebarScope.visible = true
    }
    close() {
        this.sidebarScope.visible = false
        this.sidebarScope.visibleInternal = false
    }
    toggle() {
        this.sidebarScope.visible = !this.sidebarScope.visible
        this.sidebarScope.visibleInternal = this.sidebarScope.visible
    }
}

$uniUP.directive("sidebarPanel", [
    "$timeout",
    "$log",
    "UniConfig",
    (
        $timeout: ng.ITimeoutService,
        $log: ng.ILogService,
        UniConfig: IUniConfig
    ) => ({
        // new SidebarForm($timeout, $log, UniConfig)
        restrict: "E",
        transclude: true,
        scope: {
            key: "@",
            idpanel: "@",
            visible: "=",
            title: "@",
            open: "@",
            onClose: "&"
        },
        require: ["?^^sidebarManager"],
        template: require("./sidebar-panel.inline.html"),
        link: (
            scope: ISidebarScope,
            element: JQLite,
            attrs: ng.IAttributes,
            ctrls: [SidebarManagerController] | undefined
        ) => {
            $log.debug("Instanciando sidebarpanel", scope, ctrls)

            //registrar en sidebar manager si hay key y si se encuentra el sidebar manager
            if (scope.key) {
                let sidebar = new SidebarController(scope)

                if (ctrls && ctrls[0]) {
                    ctrls[0].registraSidebar(scope.key, sidebar)
                } else {
                    console.warn("No está registrado el sidebar manager para registrar sidebar con key ", scope.key)
                }
            }

            scope.$watch(
                () => {
                    return scope.visible
                },
                val => {
                    if (val) {
                        angular.element("html").addClass("opened")

                        $log.info("Sidebar abierto")

                        $timeout(() => {
                            scope.visibleInternal = true
                            element.find(".sidebarform-visible").addClass("in show")
                        }, 300)
                    } else
                        $timeout(() => {
                            angular.element("html").removeClass("opened")

                            $log.info("Sidebar cerrado")

                            scope.visibleInternal = false
                            element.find(".sidebarform-visible").removeClass("in show")

                            // informar que se ha cerrado
                            scope.onClose()
                        }, 40)
                }
            )
        }
    })
])

/** orig unitec 20190506

class SidebarForm implements ng.IDirective<ISidebarScope> {
    restrict: "E"
    transclude: boolean
    scope: {
      key: "@"
      idpanel: "@"
      visible: "="
      title: "@"
      open: "@"
      onClose: "&"
    }
    require = ["^^sidebarManager"]

    sidebarScope: ISidebarScope

    constructor(
      private $timeout: ng.ITimeoutService,
      private $log: ng.ILogService,
      private UniConfig: up.IUniConfig
    ) {
      this.restrict = "E"

      this.scope = {
        key: "@",
        idpanel: "@",
        visible: "=",
        title: "@",
        open: "@",
        onClose: "&",
      }

      // controllerAs : 'gestionCtrl',
      // templateUrl : baseUrl + '/app/templates/vigilancia/progTrabajadoresModal.html',
      this.transclude = true
      //        templateUrl : UniConfig =>
    }

    templateUrl() {
      return this.UniConfig.baseUrl + "/templates/0unitecapp/partials/utec-sidebar-panel.html"
    }

    link(scope: ISidebarScope, element, attrs, ctrls: [SidebarManagerController]) {
      this.$log.debug("Instanciando sidebarpanel", scope, ctrls)

      this.sidebarScope = scope

      //registrar en sidebar manager
      if (scope.key) {
        let sidebar = new SidebarController(scope)

        ctrls[0].registraSidebar(scope.key, sidebar)
      }

      scope.$watch(
        () => {
          return scope.visible
        },
        val => {
          if (val) {
            angular.element("html").addClass("opened")

            this.$log.info("Sidebar abierto")

            this.$timeout(() => {
              scope.visibleInternal = true
            }, 400)
          } else
            this.$timeout(() => {
              angular.element("html").removeClass("opened")

              this.$log.info("Sidebar cerrado")

              scope.visibleInternal = false

              // informar que se ha cerrado
              scope.onClose()
            }, 40)
        }
      )
    }
  }

*/
